module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1019.e3689724.png";